module.exports = __webpack_public_path__ + "static/media/Category_Network.e51b03a9.svg";